var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _c("div", { staticClass: "modal-card-body" }, [
      _c("h1", { staticClass: "title is-4" }, [_vm._v("Permisos")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", { class: { unactive: _vm.level < 0 } }, [
          _c("b", [_vm._v("Nivel 0")]),
          _vm._v(" - Solo listar"),
        ]),
        _vm._v(" "),
        _c("li", { class: { unactive: _vm.level < 1 } }, [
          _c("b", [_vm._v("Nivel 1")]),
          _vm._v(" - Ver / Descargar"),
        ]),
        _vm._v(" "),
        _c("li", { class: { unactive: _vm.level < 2 } }, [
          _c("b", [_vm._v("Nivel 2")]),
          _vm._v(" - Descargar documento confidencial"),
        ]),
        _vm._v(" "),
        _c("li", { class: { unactive: _vm.level < 3 } }, [
          _c("b", [_vm._v("Nivel 3")]),
          _vm._v(" - Realizar acciones como firmar"),
        ]),
        _vm._v(" "),
        _c("li", { class: { unactive: _vm.level < 4 } }, [
          _c("b", [_vm._v("Nivel 4")]),
          _vm._v(" - Agregar documentos a carpeta / Modificar metadatos"),
        ]),
        _vm._v(" "),
        _c("li", { class: { unactive: _vm.level < 5 } }, [
          _c("b", [_vm._v("Nivel 5")]),
          _vm._v(" - Agregar nuevas versiones / Asociar aspectos"),
        ]),
        _vm._v(" "),
        _c("li", { class: { unactive: _vm.level < 6 } }, [
          _c("b", [_vm._v("Nivel 6")]),
          _vm._v(" - Mover o renombrar"),
        ]),
        _vm._v(" "),
        _c("li", { class: { unactive: _vm.level < 7 } }, [
          _c("b", [_vm._v("Nivel 7")]),
          _vm._v(" - Eliminar "),
        ]),
        _vm._v(" "),
        _c("li", { class: { unactive: _vm.level < 8 } }, [
          _c("b", [_vm._v("Nivel 8")]),
          _vm._v(" - Modificar permisos"),
        ]),
        _vm._v(" "),
        _c("li", { class: { unactive: _vm.level < 9 } }, [
          _c("b", [_vm._v("Nivel 9")]),
          _vm._v(" - Propietario "),
          _c("i", { staticClass: "fas fa-star" }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }